@if (formInput?.invalid) {
  <div class="alert alert-warning mt-4" id="globalErrorWarning">
    <span class="requiredIcon fa fa-exclamation-triangle"></span>
    <em class="requiredText">Please correct the highlighted items before proceeding</em>
  </div>
}
